import { render, staticRenderFns } from "./PoyntBusinessId.vue?vue&type=template&id=aa992658&"
import script from "./PoyntBusinessId.vue?vue&type=script&lang=ts&"
export * from "./PoyntBusinessId.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports